import imgBonus1 from './Bonus Games/bonus-1.png'
import imgBonus2 from './Bonus Games/bonus-2.png'
import imgBonus3 from './Bonus Games/bonus-3.png'
import imgBonus4 from './Bonus Games/bonus-4.png'
import imgBonus5 from './Bonus Games/bonus-5.png'
import imgBonus6 from './Bonus Games/bonus-6.png'

import imgDay1 from './Days/Daystreak-1.png'
import imgDay2 from './Days/Daystreak-2.png'
import imgDay3 from './Days/Daystreak-3.png'
import imgDay4 from './Days/Daystreak-4.png'
import imgDay5 from './Days/Daystreak-5.png'

import imgGames1 from './Games Played/games-1.png'
import imgGames2 from './Games Played/games-2.png'
import imgGames3 from './Games Played/games-3.png'
import imgGames4 from './Games Played/games-4.png'
import imgGames5 from './Games Played/games-5.png'
import imgGames6 from './Games Played/games-6.png'
import imgGames7 from './Games Played/games-7.png'
import imgGames8 from './Games Played/games-8.png'

import imgHoney1 from './Honey Earned/honey-1.png'
import imgHoney2 from './Honey Earned/honey-2.png'
import imgHoney3 from './Honey Earned/honey-3.png'
import imgHoney4 from './Honey Earned/honey-4.png'
import imgHoney5 from './Honey Earned/honey-5.png'
import imgHoney6 from './Honey Earned/honey-6.png'
import imgHoney7 from './Honey Earned/honey-7.png'

import imgLevel1 from './Level/Level-1.png'
import imgLevel2 from './Level/Level-2.png'
import imgLevel3 from './Level/Level-3.png'
import imgLevel4 from './Level/Level-4.png'
import imgLevel5 from './Level/Level-5.png'
import imgLevel6 from './Level/Level-6.png'
import imgLevel7 from './Level/Level-7.png'

import imgMultiplier1 from './Multiplier/multiplier-1.png'
import imgMultiplier2 from './Multiplier/multiplier-2.png'
import imgMultiplier3 from './Multiplier/multiplier-3.png'
import imgMultiplier4 from './Multiplier/multiplier-4.png'
import imgMultiplier5 from './Multiplier/multiplier-5.png'
import imgMultiplier6 from './Multiplier/multiplier-6.png'
import imgMultiplier7 from './Multiplier/multiplier-7.png'

import imgReferral1 from './Referrals/referral-1.png'
import imgReferral2 from './Referrals/referral-2.png'
import imgReferral3 from './Referrals/referral-3.png'
import imgReferral4 from './Referrals/referral-4.png'
import imgReferral5 from './Referrals/referral-5.png'
import imgReferral6 from './Referrals/referral-6.png'
import imgReferral7 from './Referrals/referral-7.png'

export type AchievementMetadata = {
  totalGamesPlayed: number
  referralsCount: number
  highestMultiplier: number
  bonusGamesReached: number
  highestBonusLevel: number
  maxDailyStreak: number
  currentDailyStreak: number
  honeyEarned: number
}

export type AchievementCategory =
  | 'Bonus'
  | 'Streak'
  | 'Honey'
  | 'Multiplier'
  | 'Referrals'

export type Achievement = {
  category: AchievementCategory
  title: string
  description: string
  image: string
  getProgress: (metadata: AchievementMetadata) => number
}

const BONUS_GAMES_ACHIEVEMENTS: Achievement[] = [
  {
    category: 'Bonus',
    title: 'Bonus Breakthrough',
    description: 'Reach 1 bonus game',
    image: imgBonus1,
    getProgress: (metadata) => metadata.bonusGamesReached / 1,
  },
  {
    category: 'Bonus',
    title: 'Bonus Regular',
    description: '3 bonus games',
    image: imgBonus2,
    getProgress: (metadata) => metadata.bonusGamesReached / 3,
  },
  {
    category: 'Bonus',
    title: 'Bonus Hunter',
    description: '5 bonus games',
    image: imgBonus3,
    getProgress: (metadata) => metadata.bonusGamesReached / 5,
  },
  {
    category: 'Bonus',
    title: 'Bonus Adventurer',
    description: '10 bonus games',
    image: imgBonus4,
    getProgress: (metadata) => metadata.bonusGamesReached / 10,
  },
  {
    category: 'Bonus',
    title: 'Bonus Champion',
    description: '20 bonus games',
    image: imgBonus5,
    getProgress: (metadata) => metadata.bonusGamesReached / 20,
  },
  {
    category: 'Bonus',
    title: 'Bonus Legend',
    description: '50 bonus games',
    image: imgBonus6,
    getProgress: (metadata) => metadata.bonusGamesReached / 50,
  },
]

const DAYS_STREAK_ACHIEVEMENTS: Achievement[] = [
  {
    category: 'Streak',
    title: 'Daily Start',
    description: '1 day streak',
    image: imgDay1,
    getProgress: (metadata) => metadata.maxDailyStreak / 1,
  },
  {
    category: 'Streak',
    title: 'Streaking',
    description: '3 day streak',
    image: imgDay2,
    getProgress: (metadata) => metadata.maxDailyStreak / 3,
  },
  {
    category: 'Streak',
    title: 'Habit Builder',
    description: '7 day streak',
    image: imgDay3,
    getProgress: (metadata) => metadata.maxDailyStreak / 7,
  },
  {
    category: 'Streak',
    title: 'Committed',
    description: '14 day streak',
    image: imgDay4,
    getProgress: (metadata) => metadata.maxDailyStreak / 14,
  },
  {
    category: 'Streak',
    title: 'Unbreakable',
    description: '30 day streak',
    image: imgDay5,
    getProgress: (metadata) => metadata.maxDailyStreak / 30,
  },
]

const GAMES_PLAYED_ACHIEVEMENTS: Achievement[] = [
  {
    category: 'Streak',
    title: 'First Game',
    description: 'Play 1 game',
    image: imgGames1,
    getProgress: (metadata) => metadata.totalGamesPlayed / 1,
  },
  {
    category: 'Streak',
    title: 'Getting Warm',
    description: '10 games',
    image: imgGames2,
    getProgress: (metadata) => metadata.totalGamesPlayed / 10,
  },
  {
    category: 'Streak',
    title: 'Practiced',
    description: '25 games',
    image: imgGames3,
    getProgress: (metadata) => metadata.totalGamesPlayed / 25,
  },
  {
    category: 'Streak',
    title: 'Seasoned',
    description: '50 games',
    image: imgGames4,
    getProgress: (metadata) => metadata.totalGamesPlayed / 50,
  },
  {
    category: 'Streak',
    title: 'Dedicated',
    description: '100 games',
    image: imgGames5,
    getProgress: (metadata) => metadata.totalGamesPlayed / 100,
  },
  {
    category: 'Streak',
    title: 'Addict',
    description: '250 games',
    image: imgGames6,
    getProgress: (metadata) => metadata.totalGamesPlayed / 250,
  },
  {
    category: 'Streak',
    title: 'Veteran',
    description: '500 games',
    image: imgGames7,
    getProgress: (metadata) => metadata.totalGamesPlayed / 500,
  },
  {
    category: 'Streak',
    title: 'Marathoner',
    description: '1,000 games',
    image: imgGames8,
    getProgress: (metadata) => metadata.totalGamesPlayed / 1000,
  },
]

const HONEY_ACHIEVEMENTS: Achievement[] = [
  {
    category: 'Honey',
    title: 'Honey Harvester',
    description: 'Earn 10 honey',
    image: imgHoney1,
    getProgress: (metadata) => metadata.honeyEarned / 10,
  },
  {
    category: 'Honey',
    title: 'Honey Gatherer',
    description: 'Earn 50 honey',
    image: imgHoney2,
    getProgress: (metadata) => metadata.honeyEarned / 50,
  },
  {
    category: 'Honey',
    title: 'Honey Collector',
    description: 'Earn 100 honey',
    image: imgHoney3,
    getProgress: (metadata) => metadata.honeyEarned / 100,
  },
  {
    category: 'Honey',
    title: 'Honey Hoarder',
    description: 'Earn 250 honey',
    image: imgHoney4,
    getProgress: (metadata) => metadata.honeyEarned / 250,
  },
  {
    category: 'Honey',
    title: 'Honey Tycoon',
    description: 'Earn 500 honey',
    image: imgHoney5,
    getProgress: (metadata) => metadata.honeyEarned / 500,
  },
  {
    category: 'Honey',
    title: 'Honey Mogul',
    description: 'Earn 1,000 honey',
    image: imgHoney6,
    getProgress: (metadata) => metadata.honeyEarned / 1000,
  },
  {
    category: 'Honey',
    title: 'Honey Overlord',
    description: 'Earn 5,000 honey',
    image: imgHoney7,
    getProgress: (metadata) => metadata.honeyEarned / 5000,
  },
]

const LEVEL_ACHIEVEMENTS: Achievement[] = [
  // {
  //   category: 'Level',
  //   title: 'Level 1',
  //   description: 'Reach level 1',
  //   image: imgLevel1,
  //   getProgress: (metadata) => metadata.highestBonusLevel / 1,
  // },
  {
    category: 'Bonus',
    title: 'Level 2',
    description: 'Reach level 2',
    image: imgLevel2,
    getProgress: (metadata) => metadata.highestBonusLevel / 2,
  },
  {
    category: 'Bonus',
    title: 'Level 3',
    description: 'Reach level 3',
    image: imgLevel3,
    getProgress: (metadata) => metadata.highestBonusLevel / 3,
  },
  {
    category: 'Bonus',
    title: 'Level 4',
    description: 'Reach level 4',
    image: imgLevel4,
    getProgress: (metadata) => metadata.highestBonusLevel / 4,
  },
  {
    category: 'Bonus',
    title: 'Level 5',
    description: 'Reach level 5',
    image: imgLevel5,
    getProgress: (metadata) => metadata.highestBonusLevel / 5,
  },
  {
    category: 'Bonus',
    title: 'Level 6',
    description: 'Reach level 6',
    image: imgLevel6,
    getProgress: (metadata) => metadata.highestBonusLevel / 6,
  },
  {
    category: 'Bonus',
    title: 'Level 7',
    description: 'Reach level 7',
    image: imgLevel7,
    getProgress: (metadata) => metadata.highestBonusLevel / 7,
  },
]

const MULTIPLIER_ACHIEVEMENTS: Achievement[] = [
  {
    category: 'Multiplier',
    title: 'Double Up',
    description: 'Reach x2',
    image: imgMultiplier1,
    getProgress: (metadata) => metadata.highestMultiplier / 2,
  },
  {
    category: 'Multiplier',
    title: 'Triple Threat',
    description: 'Reach x3',
    image: imgMultiplier2,
    getProgress: (metadata) => metadata.highestMultiplier / 3,
  },
  {
    category: 'Multiplier',
    title: 'High Five',
    description: 'Reach x5',
    image: imgMultiplier3,
    getProgress: (metadata) => metadata.highestMultiplier / 5,
  },
  {
    category: 'Multiplier',
    title: 'Power Ten',
    description: 'Reach x10',
    image: imgMultiplier4,
    getProgress: (metadata) => metadata.highestMultiplier / 10,
  },
  {
    category: 'Multiplier',
    title: 'Quarter Surge',
    description: 'Reach x25',
    image: imgMultiplier5,
    getProgress: (metadata) => metadata.highestMultiplier / 25,
  },
  {
    category: 'Multiplier',
    title: 'Half Century',
    description: 'Reach x50',
    image: imgMultiplier6,
    getProgress: (metadata) => metadata.highestMultiplier / 50,
  },
  {
    category: 'Multiplier',
    title: 'Mythic 97',
    description: 'Reach x97',
    image: imgMultiplier7,
    getProgress: (metadata) => metadata.highestMultiplier / 97,
  },
]

const REFERRAL_ACHIEVEMENTS: Achievement[] = [
  {
    category: 'Referrals',
    title: 'First Referral',
    description: 'Refer 1 friend',
    image: imgReferral1,
    getProgress: (metadata) => metadata.referralsCount / 1,
  },
  {
    category: 'Referrals',
    title: 'Early Promoter',
    description: 'Refer 3 friends',
    image: imgReferral2,
    getProgress: (metadata) => metadata.referralsCount / 3,
  },
  {
    category: 'Referrals',
    title: 'Friend Maker',
    description: 'Refer 5 friends',
    image: imgReferral3,
    getProgress: (metadata) => metadata.referralsCount / 5,
  },
  {
    category: 'Referrals',
    title: 'Community Builder',
    description: 'Refer 10 friends',
    image: imgReferral4,
    getProgress: (metadata) => metadata.referralsCount / 10,
  },
  {
    category: 'Referrals',
    title: 'Community Leader',
    description: 'Refer 25 friends',
    image: imgReferral5,
    getProgress: (metadata) => metadata.referralsCount / 25,
  },
  {
    category: 'Referrals',
    title: 'Community Legend',
    description: 'Refer 50 friends',
    image: imgReferral6,
    getProgress: (metadata) => metadata.referralsCount / 50,
  },
  {
    category: 'Referrals',
    title: 'Hive Founder',
    description: 'Refer 100 friends',
    image: imgReferral7,
    getProgress: (metadata) => metadata.referralsCount / 100,
  },
]

export const ACHIEVEMENTS: Achievement[] = [
  ...BONUS_GAMES_ACHIEVEMENTS,
  ...DAYS_STREAK_ACHIEVEMENTS,
  ...GAMES_PLAYED_ACHIEVEMENTS,
  ...HONEY_ACHIEVEMENTS,
  ...LEVEL_ACHIEVEMENTS,
  ...MULTIPLIER_ACHIEVEMENTS,
  ...REFERRAL_ACHIEVEMENTS,
]
